import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, shareReplay, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CentrexUserModel } from '../models/centrex-user.model';

@Injectable({ providedIn: 'root' })
export class CentrexUsersService {
  private baseUrl = `${environment.apiUrl}/api/centrex/users`;
  private usersCache = new Map<string, Observable<CentrexUserModel[]>>();

  constructor(private http: HttpClient) {}

  getAllCentrexUsers(
    orgId: string,
    platform: string,
  ): Observable<CentrexUserModel[]> {
    const cacheKey = `${orgId}_${platform}`;

    // retourne le cache si présent
    if (this.usersCache.has(cacheKey)) {
      return this.usersCache.get(cacheKey)!;
    }

    const headers = this.buildHeaders(orgId, platform);

    const request$ = this.http
      .get<CentrexUserModel[]>(this.baseUrl, { headers })
      .pipe(
        shareReplay(1),

        catchError((error) => {
          this.usersCache.delete(cacheKey);
          return throwError(() => error);
        }),
      );

    this.usersCache.set(cacheKey, request$);

    return request$;
  }
  getCentrexUserById(
    userId: string,
    orgId: string,
    platform: string,
  ): Observable<CentrexUserModel> {
    const headers = this.buildHeaders(orgId, platform);
    return this.http.get<CentrexUserModel>(`${this.baseUrl}/${userId}`, {
      headers,
    });
  }

  updateCentrexUser(
    userId: string,
    model: CentrexUserModel,
    orgId: string,
    platform: string,
  ): Observable<void> {
    const headers = this.buildHeaders(orgId, platform);

    return this.http
      .patch<void>(`${this.baseUrl}/${userId}`, model, { headers })
      .pipe(
        tap(() => {
          const cacheKey = `${orgId}_${platform}`;

          this.usersCache.delete(cacheKey);
        }),
      );
  }

  private buildHeaders(orgId: string, platform: string): HttpHeaders {
    return new HttpHeaders({
      'X-OrganizationId': orgId,
      'X-CentrexPlatform': platform,
    });
  }

  clearCache(): void {
    this.usersCache.clear();
  }
}
